module.exports = __webpack_public_path__ + "static/media/flag-ko.88a61ba1.webp";